import '@angular/localize/init';
export * from './lib/feature-tax-tasks-list.module';

export * from './lib/tax-tasks-list/feature-tax-tasks-list.component';
